@if (connectEnabled$ | async) {
<atx-business-contacts
  [contacts]="contacts$ | async"
  (showAll)="go()"
  [showShowAllButton]="showShowAllButton$ | async"
>
  <div class="pre-contact-list">
    @if (isChromeIOS) {
    <atx-alert>
      <span i18n="Connect@@browserNotSupported">
        Connect is available only in Safari on your iPhone.
      </span>
    </atx-alert>
    }
  </div>
  <ng-template #contactsList let-contacts>
    @if (show) {
    <epc-contact-list
      [contacts]="contacts"
      (call)="setCurrentContact($event)"
      [userCalling]="userCalling$ | async"
    ></epc-contact-list>
    }
  </ng-template>
  <div class="post-content">
    @if (show) { @if (notificationsNotAllowed$ | async) {
    <atx-alert [icon]="['fas', 'bell']" [severity]="severity">
      <span i18n="Connect@@notificationPermissionNotGranted">
        Enjoy the full experience of Connect allowing notifications on the
        browser
      </span>
    </atx-alert>
    } }
  </div>
</atx-business-contacts>
}
